module.exports = __webpack_public_path__ + "static/media/checkedRing.208927a9.svg";